import * as Icons from "lucide-react";
import { Reveal } from "./Reveal";
import { TRUST_ITEMS } from "../data/site";

export const Trust = () => (
  <section data-testid="trust-section" className="bg-[#050505] px-6 py-24 md:px-12 md:py-28">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
      {TRUST_ITEMS.map((item, i) => {
        const Icon = Icons[item.icon];
        return (
          <Reveal key={item.title} delay={i * 0.08} className="bg-[#050505]">
            <div
              data-testid={`trust-item-${i + 1}`}
              className="group h-full bg-[#0A0A0A] p-8 transition-colors duration-500 hover:bg-[#0D1420]"
            >
              <Icon size={30} strokeWidth={1.5} className="text-[#0055FF] transition-transform duration-500 group-hover:-translate-y-1" />
              <h3 className="mt-6 font-display text-lg font-semibold tracking-tight">{item.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#A3A3A3]">{item.desc}</p>
            </div>
          </Reveal>
        );
      })}
    </div>
  </section>
);
